import { gql } from '@apollo/client';
import { AgentActivityLog, AgentActivityLogOutcome, AgentActivityLogProcessType } from '@trnsact/trnsact-shared-types';

export const GET_AGENT_ACTIVITY = gql`
  query GetAgentActivity($input: GetAgentActivityInput!) {
    getAgentActivity(input: $input) {
      agentActivityLogId
      agentExecutionId
      processType
      trigger
      payload
      error
      associations
      outcome
      createdDateTime
    }
  }
`;

export interface GetAgentActivityResponse {
  getAgentActivity: AgentActivityLog[] | null;
}

export interface GetAgentActivityInput {
  from: string;
  to: string;
  outcome?: AgentActivityLogOutcome | null;
  processType?: AgentActivityLogProcessType | null;
}
